import { nextTick, ref } from 'vue';
import $ from 'jquery';

const useModalHook = () => {
  const isOpen = ref(false);

  const showModal = ({ immediate = false } = {}) => {
    $('body').addClass('no-scroll');

    if (immediate) {
      $('.modal-overlay').addClass('show');
    } else {
      $('.modal-overlay').fadeIn().addClass('show');
    }

    // necessary to remove the 'display' style that was added automatically before from 'fadeOut' (ref. 'closeModal' method)
    $('.modal-content').fadeIn(0);
  };

  const hideModalWithCallback = ({ immediate = false, afterHideCallback } = {}) => {
    $('body').removeClass('no-scroll');
    $('.modal-overlay').removeClass('show');

    const __afterHideCallback = () => {
      isOpen.value = false;

      if (afterHideCallback) {
        afterHideCallback();
      }
    };

    const modalContentElement = $('.modal-content');
    if (modalContentElement && modalContentElement.length > 0) {
      const fadeOutDuration = immediate ? 0 : undefined;
      modalContentElement.fadeOut(fadeOutDuration, __afterHideCallback);
    } else {
      __afterHideCallback();
    }
  };

  const hideModalWithPromise = ({ immediate = false } = {}) => new Promise((resolve) => {
    $('body').removeClass('no-scroll');
    $('.modal-overlay').removeClass('show');

    const afterHideCallback = () => {
      isOpen.value = false;

      resolve();
    };

    const modalContentElement = $('.modal-content');
    if (modalContentElement && modalContentElement.length > 0) {
      const fadeOutDuration = immediate ? 0 : undefined;
      modalContentElement.fadeOut(fadeOutDuration, afterHideCallback);
    } else {
      afterHideCallback();
    }
  });

  const openModal = (
    {
      showImmediate = false,
      hideImmediate = false,
      hideManually = false,
      afterHideCallback,
    } = {},
  ) => {
    isOpen.value = true;

    nextTick(() => {
      showModal({ immediate: showImmediate });

      if (!hideManually) {
        $('.modal-overlay, .close-btn, .close_modal').click(event => {
          if (!$(event.target).hasClass('no_close')) {
            hideModalWithCallback({ immediate: hideImmediate, afterHideCallback });
          }
        });

        // allow user to interact with content inside the modal
        $('.modal-content').click(event => {
          event.stopPropagation();
        });
      }
    });
  };

  const closeModal = ({ immediate = false, type = 'usePromise', afterHideCallback } = {}) => {
    if (type === 'usePromise') {
      return hideModalWithPromise({ immediate });
    } else if (type === 'useCallback') {
      return hideModalWithCallback({ immediate, afterHideCallback });
    }
  };

  return [
    isOpen,
    openModal,
    closeModal,
  ];
};

export default useModalHook;
